<template>
  <div >
    <search-bar ref="searchBarComponent">

      <div slot="search-cont">

        <div class="item">
          <div class="item-label">类型</div>
            <el-select size="small"  clearable v-model="search.type" placeholder="类型" @change="handleSeach()" style="width: 100%;">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
        </div>

        <div class="item" >
          <div class="item-label">记录日期</div>
           <el-date-picker @change="handleSeach()" v-model="search.date" type="datetimerange" value-format="yyyy-MM-dd"
                        range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" size="small"></el-date-picker>
        </div>
        <div class="item">
          <div class="item-label">关键词搜索</div>
          <div style="width: 300px;">
            <el-input placeholder="请输入内容" v-model="search.key" class="input-with-select" size="small" @keyup.enter.native='handleSeach'>
              <el-select v-model="search.key_type" slot="prepend" placeholder="请选择" @change="selectChange" style="width: 130px"
                size="small">
                <el-option v-for="item in options1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value" ></el-option>

              </el-select>
              <el-button slot="append" icon="el-icon-search" @click='handleSeach' size="small"></el-button>
            </el-input>


          </div>
        </div>

        <!--  操作按钮 start -->
          <div class="item">
            <el-button class="item-btn" type="primary" @click="handleSeach">查询</el-button>

          </div>
        <!--  操作按钮 end -->

      </div>
    </search-bar>

    <div class="l-panel">
      <div class="panel-body">
      <el-table class="l-table" stripe=""
        ref="multipleTable"
        :data="tableData"
        style="width: 100%"
        :default-sort="{ prop: 'date', order: 'descending' }"
        @selection-change="hanleSelection"
      >

        <el-table-column prop="log_username" label="会员名" width="150">
            <template slot-scope="{ row }">
                <span>{{row.log_username}}</span><span> (ID : {{row.log_uid}} ) </span>
            </template>
        </el-table-column>
        <el-table-column prop="log_source" label="类型" width="200"> </el-table-column>
        <el-table-column prop="log_addtime" label="创建时间" width="200"> </el-table-column>
        <el-table-column prop="log_ip" label="IP" align="right" width="200"> </el-table-column>
        <!-- <el-table-column prop="operater" label="管理员"> </el-table-column> -->
        <el-table-column prop="log_value" label="描述"> </el-table-column>
      </el-table>

      <div class="c-table-pager">

        <el-pagination
          @current-change="handleCurrentChange"
          :page-size="10"

          :total="total"
        >
        </el-pagination>
      </div>

    </div>
    </div>

  </div>
</template>

<script>
import { Message } from "element-ui";
export default {
  data() {
    return {
      search: {key_type:'1',page:1},
      tableData: [],
      options:[
          {value:'1',label:'用户操作'},
          {value:'2',label:'后台操作'},
      ],
      options1:[
          {
              value:'1',
              label:'会员名'
          },
          {
              value:'2',
              label:'会员UID'
          },
          {
              value:'3',
              label:'管理员'
          },
          {
              value:'4',
              label:'公管理员id'
          },
          {
              value:'5',
              label:'职位id'
          },
          {
              value:'6',
              label:'公司id'
          },
          {
              value:'7',
              label:'简历id'
          },
          {
              value:'8',
              label:'操作内容'
          },
      ],
      total: 1,
      Selection_id:''
    };
  },
  activated() {
      this.getData()
  },
  methods: {
                //分页
    handleCurrentChange(val) {
      this.search.page = val;
      this.getData();
    },
          //全选
    hanleSelection(e) {
      let arr = [];
      for (const i in e) {
        arr.push(e[i].link_id);
      }
      this.Selection_id = arr.toString();
    },
    handleSeach() {
      this.search.page = 1;
      this.getData();
    },
    selectChange() {
      this.$forceUpdate()
    },
    getData() {
        if (this.search.date) {
        this.search.begintime = this.search.date[0];
        this.search.endtime = this.search.date[1];
      } else {
        this.search.begintime = "";
        this.search.endtime = "";
      }
      this.gets("MembersLog/index", this.search).then((res) => {
        this.tableData = res.data.data.list;
        this.total = res.data.data.total;
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/system/MembersLogindex.vue